$(document).ready(function () {
  var $icons = $(".new-cart-payment-icons svg.cart-payment-icon");
  var iconCount = $icons.length;
  var $showMoreBtn = $(".show-more-btn");
  var visibleCount = 5;
  if (iconCount > visibleCount) {
    var hiddenCount = iconCount - visibleCount;
    $(".show-more-btn.w3_bg").text(`+${hiddenCount}`);
    $icons.slice(visibleCount).hide();
    $showMoreBtn.show();
    console.log("Number of hidden icons:", hiddenCount);
    $showMoreBtn.click(function () {
      if ($icons.slice(visibleCount).is(":visible")) {
        $icons.slice(visibleCount).hide();
        $showMoreBtn.text(`+${hiddenCount}`);
      } else {
        $icons.slice(visibleCount).show();
        $showMoreBtn.text("Show Less");
      }
    });
  } else {
    $showMoreBtn.hide();
  }

  var interval;
  interval = setInterval(function () {
    var text = $(".main-announcement").attr("attr");
    var numberValue = Number(text);
    $(".mobile_code").slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      dots: false,
      autoplay: true,
      autoplaySpeed: numberValue,
      vertical: true,
      verticalSwiping: true,
      arrows: true,
      prevArrow:
        "<button type='button' class='slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><polygon points='15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293'/></svg></button>",
      nextArrow:
        "<button type='button' class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><polygon points='7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707'/></svg></button>",
    });
    clearInterval(interval);
  }, 1000);

  $(".descount_head").click(function () {
    $(this).toggleClass("open_descount");
  });

  $("body").addClass("show_ann");
  // $(".main_class option").each(function( index ) {
  //  var value = $(this).val();
  //   if(value == 'CUSTOM'){
  //     $('.product-inventory-notice__text').text('');
  //   }
  // });

  let lastScrollTop = 0;

  // Listen for scroll events
  window.addEventListener("scroll", function () {
    let currentScrollTop =
      window.pageYOffset || document.documentElement.scrollTop;

    if (currentScrollTop > lastScrollTop) {
      // Scrolling down
      document.body.classList.add("scrolled-down");
      document.body.classList.remove("scrolled-up");
    } else if (currentScrollTop < lastScrollTop) {
      // Scrolling up
      document.body.classList.add("scrolled-up");
      document.body.classList.remove("scrolled-down");
    }

    // Update lastScrollTop
    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  });
});
$(document).on("change", ".main_class", function () {
  var value = $(this).val();
  if (value == "CUSTOM") {
    $(".product-inventory-notice__text").text("");
    $("button.main-add-cart-port").text("ADD TO CART");
  }
  function getQueryParam(param) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }
  var variantId = getQueryParam("variant");
  $("select.main_id_pro.original-selector option").each(function (index) {
    var one = $(this).val();
    if (variantId == one) {
      var compare_at_price = $(this).attr("compare_at_price");
      var variant_price = $(this).attr("variant_price");
      if (
        compare_at_price == variant_price ||
        compare_at_price == "" ||
        parseFloat(compare_at_price) < parseFloat(variant_price)
      ) {
        $(".main-price-count .save-price.theme-money").addClass("hide_badge");
      } else {
        $(".main-price-count .save-price.theme-money").removeClass(
          "hide_badge"
        );
      }
      var price = $(this).attr("price");
      $(".main-price-save").text(price);
    }
  });

  // $('.product-inventory-notice__text').each(function() {
  //     var text = $(this).text();
  //     console.log(text);

  //     if (text === 'Low stock') {
  //         // Get the color from the data attribute of the parent element
  //         var color = $(this).closest('.product-inventory-notice').attr('data-indicator-scale-color-below');
  //         console.log(color);

  //         // Check if the color exists and apply it to the element's text color
  //         if (color) {
  //             $(this).css("color", color); // Apply the color directly to the text element
  //         }
  //     }
  // });
});

$(document).ready(function () {
  console.log("working");
  function getQueryParam(param) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  var variantId = getQueryParam("variant");
  $("select.main_id_pro.original-selector option").each(function () {
    var optionValue = $(this).val();
    if (variantId == optionValue) {
      var compare_at_price = $(this).attr("compare_at_price");
      var variant_price = $(this).attr("variant_price");
      if (
        compare_at_price == variant_price ||
        compare_at_price == "" ||
        parseFloat(compare_at_price) < parseFloat(variant_price)
      ) {
        $(".main-price-count .save-price.theme-money").addClass("hide_badge");
      } else {
        $(".main-price-count .save-price.theme-money").removeClass(
          "hide_badge"
        );
      }
      var price = $(this).attr("price");
      $(".main-price-save").text(price);
    }
  });
});



$(document).ready(function () {
    $(".sb_variant_option").each(function () {
        if (!$(this).find('option[value=""]').length) {
            $(this).prepend('<option value="" selected>Choose your size</option>');
        }
    });
});

